/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PlatformDescriptionStatusDTOLastRun
 */
export interface PlatformDescriptionStatusDTOLastRun {
  /**
   *
   * @type {number}
   * @memberof PlatformDescriptionStatusDTOLastRun
   */
  runId: number;
  /**
   *
   * @type {string}
   * @memberof PlatformDescriptionStatusDTOLastRun
   */
  status: PlatformDescriptionStatusDTOLastRunStatusEnum;
  /**
   *
   * @type {Date}
   * @memberof PlatformDescriptionStatusDTOLastRun
   */
  finishedAt?: Date | null;
}

/**
 * @export
 */
export const PlatformDescriptionStatusDTOLastRunStatusEnum = {
  RUNNING: "RUNNING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
} as const;
export type PlatformDescriptionStatusDTOLastRunStatusEnum =
  typeof PlatformDescriptionStatusDTOLastRunStatusEnum[keyof typeof PlatformDescriptionStatusDTOLastRunStatusEnum];

/**
 * Check if a given object implements the PlatformDescriptionStatusDTOLastRun interface.
 */
export function instanceOfPlatformDescriptionStatusDTOLastRun(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "runId" in value;
  isInstance = isInstance && "status" in value;

  return isInstance;
}

export function PlatformDescriptionStatusDTOLastRunFromJSON(json: any): PlatformDescriptionStatusDTOLastRun {
  return PlatformDescriptionStatusDTOLastRunFromJSONTyped(json, false);
}

export function PlatformDescriptionStatusDTOLastRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PlatformDescriptionStatusDTOLastRun {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    runId: json["runId"],
    status: json["status"],
    finishedAt: !exists(json, "finishedAt")
      ? undefined
      : json["finishedAt"] === null
      ? null
      : new Date(json["finishedAt"])
  };
}

export function PlatformDescriptionStatusDTOLastRunToJSON(value?: PlatformDescriptionStatusDTOLastRun | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    runId: value.runId,
    status: value.status,
    finishedAt:
      value.finishedAt === undefined ? undefined : value.finishedAt === null ? null : value.finishedAt.toISOString()
  };
}
